var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "mt-3" },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.loading, rounded: "sm" } },
        [
          _c("h5", { staticClass: "mt-3" }, [
            _vm._v(_vm._s(_vm.$t("SIGNATURE"))),
          ]),
          _c(
            "div",
            { staticClass: "mt-1" },
            [
              _c("b-form-textarea", {
                attrs: { rows: "5", "max-rows": "6" },
                model: {
                  value: _vm.signature,
                  callback: function ($$v) {
                    _vm.signature = $$v
                  },
                  expression: "signature",
                },
              }),
            ],
            1
          ),
          _c("hr", { staticClass: "p-0 m-0 mt-4 mb-2" }),
          _c(
            "b-button",
            {
              staticClass: "btn-fill",
              attrs: { variant: "primary" },
              on: { click: _vm.saveSubmit },
            },
            [_vm._v(_vm._s(_vm.$t("SAVE")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }